import React from 'react';
import classnames from 'classnames';
import { Button } from 'tea-component';

import './index.scss';

import SvgIcon from '@home/components/SvgIcon';

interface IconButtonProps extends IBaseProps {
  disabled?: boolean;
  useIconFont?: boolean;
  prefix?: string;
  suffix?: string;
  onClick?: () => void;
}

const iconClassNameMap: IRecord<string> = {
  prefix: 'prefix-icon',
  suffix: 'suffix-icon',
};

const IconButton: React.FC<IconButtonProps> = (props) => {
  const { style, className, disabled, useIconFont = true, prefix, suffix, onClick } = props;

  const handleClick = () => {
    if (disabled) {
      return;
    }

    onClick?.();
  };

  const renderIcon = (type: 'prefix' | 'suffix' | string, src: string) => {
    const iconClassName = iconClassNameMap[type];

    if (useIconFont) {
      return <SvgIcon className={iconClassName} type={src as string} />;
    }

    return <img className={iconClassName} src={src} alt="" />;
  };

  return (
    <>
      <Button
        style={style}
        className={classnames('dbi-common-iconbtn', className, {
          'is-disabled': disabled,
        })}
        disabled={disabled}
        onClick={handleClick}
      >
        {prefix && renderIcon('prefix', prefix)}
        {props.children}
        {suffix && renderIcon('suffix', suffix)}
      </Button>
    </>
  );
};

export default IconButton;
